import Cookies from "js-cookie";

export default {
	search,
	autoSuggest,
	productSearchTerms,
	bookProductSearchTerms,
};

async function bookProductSearchTerms() {
	try {
		let apiResp = await fetch(`/api/bookSearch`);

		apiResp = await responseJson(apiResp);

		if (apiResp.err || !apiResp.bookSearchTerms || !apiResp.bookSearchTerms) {
			throw new Error("Error auto suggest");
		} else {
			return apiResp.bookSearchTerms;
		}
	}
	catch (err) {
		console.error(err);
	}
}

async function productSearchTerms() {
	try {
		let apiResp = await fetch(`/api/productSearch`);

		apiResp = await responseJson(apiResp);

		if (apiResp.err || !apiResp.productCollection || !apiResp.productCollection?.items) {
			throw new Error("Error auto suggest");
		} else {
			return apiResp.productCollection.items;
		}
	}
	catch (err) {
		console.error(err);
	}
}

async function autoSuggest(value) {
	try {
		let apiResp = await fetch(`/api/autosuggest?q=${value}`);

		apiResp = await responseJson(apiResp);

		if (apiResp.err || !apiResp.resp) {
			throw new Error("Error auto suggest");
		} else {
			return apiResp.resp;
		}
	}
	catch (err) {
		console.error(err);
	}
}

const responseJson = async (res) => {
	if (res.ok) {
		return res.text().then((text) => (text.length ? JSON.parse(text) : null));
	}
	else {
		return Promise.reject(res);
	}
};

async function search(query) {
	try {
		const { value, page = 0 } = query;
		const resp = await fetch(`/api/search?q=${value}&page=${page}`);
		const result = await responseJson(resp);

		if (result.err || !result.resp) {
			throw new Error("Error Search");
		} else {
			return result.resp;
		}
	}
	catch (err) {
		console.error(err);
	}
}
